import * as React from "react"
import { sanitize } from "§/src/utils/functions"
import { removeTags } from "§/src/utils/functions"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
const ModalRight = React.lazy(() =>
  import("§/src/components/atoms/content/modal-right")
)

/**
 * Internal dependencies.
 */
import "./_tile-content-person.scss"

const TileContentPerson = ({ name, title, image, content, ...atomProps }) => {
  // set atom class
  const atomClassName = "tile-content-person"
  var atomClass =
    atomProps.className != undefined
      ? atomClassName + " " + atomProps.className
      : atomClassName

  const modalid = "modal-" + Math.floor(Math.random() * 9999)

  return (
    <div className={atomClass} {...atomProps}>
      {content ? (
        <>
          <div
            className="card"
            data-bs-toggle="modal"
            data-bs-target={`#${modalid}`}
          >
            <div className="flex flex-column gap-3">
              <div className="flex flex-column gap-1">
                <div className="meta">
                  {name && (
                    <p
                      className="fs-20 mb-0 person-name"
                      dangerouslySetInnerHTML={{ __html: sanitize(name) }}
                    />
                  )}
                  {title && (
                    <p
                      className="fs-14 title mb-0 person-title"
                      dangerouslySetInnerHTML={{
                        __html: sanitize(removeTags(title)),
                      }}
                    />
                  )}
                </div>
                {image && (
                  <div className="image">
                    <GatsbyImage
                      className="sw-image"
                      image={getImage(image?.gatsbyImage)}
                      objectFit="cover"
                      alt={image?.altText || ""}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <ModalRight modalid={modalid}>
            <div className="row">
              <div className="d-none d-lg-block col-lg-2 col-xl-1"></div>
              <div className="d-flex flex-column gap-7">
                <div className="d-flex flex-column gap-3">
                  {name && <h4 className="fw-bold m-0">{name}</h4>}
                  {title &&
                    <h4 className="mb-0" dangerouslySetInnerHTML={{
                      __html: sanitize(removeTags(title)),
                    }}/>
                  }
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: sanitize(content),
                  }}
                />
                {image && (
                  <div className="image pb-5">
                    <GatsbyImage
                      className="sw-image"
                      image={getImage(image?.gatsbyImage)}
                      objectFit="cover"
                      alt={image?.altText || ""}
                    />
                  </div>
                )}
              </div>
            </div>
          </ModalRight>
        </>
      ) : (
        <div className="card">
          <div className="flex flex-column gap-3">
            <div className="flex flex-column gap-1">
              <div className="meta">
                {name && <p className="fs-20 mb-0 person-name">{name}</p>}
                {title && (
                  <p
										className="fs-14 title mb-0 person-title"
										dangerouslySetInnerHTML={{
											__html: sanitize(removeTags(title)),
										}}
									/>
                )}
              </div>
              {image && (
                <div className="image">
                  <GatsbyImage
                    className="sw-image"
                    image={getImage(image?.gatsbyImage)}
                    objectFit="cover"
                    alt={image?.altText || ""}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default TileContentPerson
